module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.current_user.isAdmin()) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeNotificationDropdown),
      expression: "closeNotificationDropdown"
    }],
    staticClass: "notification-dropdown-button"
  }, [_c('div', {
    staticClass: "clickable",
    on: {
      "click": _vm.toggleNotificationDropdown
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/notifications.svg"),
      "width": "106",
      "alt": "Reev"
    }
  }), (_vm.notifications_count > 0) ? _c('span', {
    staticClass: "notifications-count"
  }, [_vm._v(_vm._s(_vm.notifications_count))]) : _vm._e()]), _c('notification-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_notifications_dropdown),
      expression: "show_notifications_dropdown"
    }],
    on: {
      "close": _vm.closeNotificationDropdown
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45137450!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/notifications/bell.vue
// module id = 1090
// module chunks = 1